import React, { memo } from 'react';

/**
 * @param {{
 *  tabKey: string;
 *  selectedKey: string;
 *  message: string;
 *  doNotDisplayAsTabContent: boolean;
 * }} param 
 * @returns {React.JSX.Element}
 */
const InProgressWithoutMemo = ({
  tabKey = '',
  selectedKey = '',
  message = 'Development work is in progress. Please try later.',
  doNotDisplayAsTabContent = false,
}) => {
  const displayClass = tabKey !== selectedKey ? 'd-none' : '';

  return (
    <div
      className={`
        flex
        flex-fill
        font-14
        ${doNotDisplayAsTabContent ? 'min-height-40' : 'column-content'}
        scroll-y-auto
        ${displayClass}
      `}
    >
      <div className='flex flex-fill align-items-center in-progress height-40 p-l-3 p-r-3'>
        {message}
      </div>
    </div>
  );
};

export const InProgress = memo(InProgressWithoutMemo);

export default InProgress;
